import { render, staticRenderFns } from "./InsertPkgCode.vue?vue&type=template&id=6efc9ecf&scoped=true&"
import script from "./InsertPkgCode.vue?vue&type=script&lang=js&"
export * from "./InsertPkgCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efc9ecf",
  null
  
)

export default component.exports